import React, { Component } from 'react';
import logo from '../../Logo_Gregg.svg';
import confirm from '../../confirm.svg';
import './index.css';
import {Link} from 'react-router-dom';
import request from '../client/client';

class CupomData extends Component {

  state = {
    dateConverted: ""
  }
  
  componentDidMount() {
    this.dateConvert();
  }

  openModal = () => {
    var modal = document.getElementById('modal');
    var overlay = document.getElementById('overlay');
    modal.style.display = "block";
    overlay.style.display = "block";
  }

  useCoupon = () => {
    try {
      request.get(`/cashiers/check/${this.props.location.state.couponCode}/${localStorage.getItem("id")}`);

      this.props.history.push({
        pathname: '/cupomRescued', 
        state: { 
          name: this.props.location.state.name
      }});
    } catch(error) {
      this.props.history.replace('/cupomRescuedError');
    }
  }

  closeModal = () => {
    var modal = document.getElementById('modal');
    var overlay = document.getElementById('overlay');
    modal.style.display = "none";
    overlay.style.display = "none";
  }

  dateConvert = () => {
    const date = this.props.location.state.date.split("T");
    const dateSplited = date[0].split("-");
    this.setState({
      dateConverted: `${dateSplited[2]}/${dateSplited[1]}/${dateSplited[0]}`
    })
  }

  render() {
    return (
      <div className="text-center">
        <img className="gregg-logo" src={logo} alt="gregg" width="135"/>
        <div className="content-container text-left retrieves-div">
          <p>Nome do Cliente</p>
          <div className="retrieves">{this.props.location.state.name}</div>
          <p>Item do resgate</p>
          <div className="retrieves">{this.props.location.state.item}</div>
          <p>Data</p>
          <div className="retrieves">{this.state.dateConverted}</div>
        </div>
        <input
            className="form-submit check confirmation"
            value="Confirmar"
            type="submit"
            onClick={this.openModal}
          />
        <Link className="check-again" to={`/`}>Nova consulta</Link>
        
        <div id="overlay"></div>
        <div id="modal">
          <div className="content modal-content">
            <img src={confirm} alt="ícone de verificar" />
            <h3 className="strong">Confirmar</h3>
            <h3>este resgate?</h3>
            <input
              className="form-submit check yes"
              value="Sim"
              type="submit"
              onClick={this.useCoupon}
            />
            <input
              className="form-submit check no"
              value="Não"
              type="submit"
              onClick={this.closeModal}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default CupomData;



// WEBPACK FOOTER //
// ./src/components/cupomData/index.js